import { render, staticRenderFns } from "./WorkIconClose.vue?vue&type=template&id=70105850"
import script from "./WorkIconClose.vue?vue&type=script&lang=js"
export * from "./WorkIconClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports